import {
  Flex, Icon, IconButton, Text, Box, Spacer,
  Menu, MenuButton, MenuList, MenuItem, Tooltip,
} from "@chakra-ui/react";
import {
  MdChevronRight,
  MdEdit,
  MdDelete,
} from "react-icons/md";
import { FcFolder, FcOpenedFolder } from "react-icons/fc";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaFolderPlus } from "react-icons/fa";

export default function Folder({
  Item, 
  OnSelect, 
  OnChange, 
  OnToggleFolder, 
  OpenFolders, 
  Selected, 
  level = 0, 
  RenderFolders,
  texts = {} 
}) {
  const fileManagerTexts = texts?.fileManager || {};
  
  const isOpen = !!OpenFolders[Item.FolderId];
  const isSelected = Selected === Item.FolderId;
  const hasChildren = Item.Children && Item.Children.length > 0;
  const paddingLeft = `${level * 20 + 5}px`;


  return (
    <Box pl={paddingLeft} sx={{ color: 'var(--fm-folder-text)'}}>
      <Flex
        align="center"
        w="100%"
        p={1.5}
        borderRadius="md"
        cursor="pointer"
        onClick={() => OnSelect(Item)}
        className="folder-item"
        sx={{
          bg: isSelected ? '#rgba(52, 51, 51, 0)' : '#rgba(52, 51, 51, 0)',
          _hover: { 
            bg: isSelected ? '#rgba(52, 51, 51, 0)' : 'rgba(52, 51, 51, 0)' 
          }
        }}
      >
        <IconButton
          icon={<MdChevronRight />}
          variant="ghost"
          size="sm"
          aria-label={fileManagerTexts.ariaLabels?.toggleChildren || "Toggle children"}
          transform={isOpen ? "rotate(90deg)" : "none"}
          transition="transform 0.2s"
          onClick={(e) => {
            e.stopPropagation();
            OnToggleFolder(Item.FolderId);
          }}
          visibility={hasChildren ? "visible" : "hidden"}
          sx={{
            color: 'var(--fm-folder-icon-color)',
            _hover: { 
              color: 'var(--fm-folder-icon-hover-color)',
              bg: 'rgba(52, 51, 51, 0)'
            }
          }}
        />
        
        <Icon 
          as={isOpen ? FcOpenedFolder : FcFolder} 
          boxSize="1.5rem" 
          mx={1} 
        />
        
        {/* [DEBUG] isLazy prevents portal from mounting until hover — key suspect for removeChild */}
        <Tooltip label={Item.FolderName} placement="top-start" openDelay={500} isLazy>
          <Text noOfLines={1} fontSize="sm">{Item.FolderName}</Text>
        </Tooltip>

        <Spacer />
        {/* [DEBUG] isLazy prevents MenuList portal from mounting until click — key suspect */}
        <Menu isLazy>
  <MenuButton
    as={IconButton}
    icon={<BsThreeDotsVertical />}
    variant="ghost"
    size="sm"
    aria-label={fileManagerTexts.ariaLabels?.options || "Options"}
    onClick={(e) => e.stopPropagation()}
    sx={{
      color: 'var(--fm-folder-icon-color)',
      _hover: { 
        color: 'var(--fm-folder-icon-hover-color)', 
        bg: 'rgba(52, 51, 51, 0)' 
      }
    }}
  />
  <MenuList 
    sx={{
      bg: '#ffffff',
      borderColor: '#e0e0e0',
      color: '#333333',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    }}
  >
    <MenuItem 
      icon={<FaFolderPlus />} 
      onClick={(e) => { 
        e.stopPropagation(); 
        OnChange({ 
          IsOpen: true, 
          Tab: "Create", 
          ParentId: Item.FolderId 
        }); 
      }}
      sx={{ 
        bg: '#ffffff', 
        _hover: { bg: '#f5f5f5' }
      }}
    >
      {fileManagerTexts.addSubFolder || "Add sub-folder"}
    </MenuItem>
    <MenuItem 
      icon={<MdEdit />} 
      onClick={(e) => { 
        e.stopPropagation(); 
        OnChange({ 
          IsOpen: true, 
          Tab: "Edit", 
          FolderId: Item.FolderId, 
          FolderName: Item.FolderName 
        }); 
      }}
      sx={{ 
        bg: '#ffffff',
        _hover: { bg: '#f5f5f5' } 
      }}
    >
      {fileManagerTexts.rename || "Rename"}
    </MenuItem>
    <MenuItem 
      icon={<MdDelete />} 
      onClick={(e) => { 
        e.stopPropagation(); 
        OnChange({ 
          IsOpen: true, 
          Tab: "Delete", 
          FolderId: Item.FolderId 
        }); 
      }}
      sx={{ 
        bg: '#ffffff',
        color: '#e53e3e',
        _hover: { 
          bg: '#fff5f5', 
          color: '#c53030',
        } 
      }}
    >
      {fileManagerTexts.delete || "Delete"}
    </MenuItem>
  </MenuList>
</Menu>
      </Flex>
      
      {isOpen && hasChildren && (
        <Box>
          {RenderFolders(Folder, Item.Children, { 
            OnSelect, 
            OnChange, 
            OnToggleFolder, 
            OpenFolders, 
            Selected, 
            level: level + 1,
            texts 
          })}
        </Box>
      )}
    </Box>
  );
}